import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import {
  IPlInsightBenchMarkData,
  IUpsertMetricDefinitionPayload,
  IFetchMetricDefinitionsParams,
  IHabitationalMetricData,
  IUpsertHabitationalMetricPayload,
} from "./dashboardSettings.types";

export const fetchMetricDefinitions = createAsyncThunk<
  { data: IPlInsightBenchMarkData[]; totalRecords: number },
  IFetchMetricDefinitionsParams,
  { rejectValue: string }
>(
  "dashboardSettings/fetchMetricDefinitions",
  async ({ pageNumber, rowsInPerPage, limit }, thunkAPI) => {
    try {
      const res = await api.get(
        `/policy/get-metric-definition?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&pageLimit=${limit}`,
      );
      const data: IPlInsightBenchMarkData[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      return { data, totalRecords };
    } catch (err: any) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message ||
          err.message ||
          "Failed to fetch metric definitions",
      );
    }
  },
);

export const upsertMetricDefinition = createAsyncThunk<
  IPlInsightBenchMarkData,
  IUpsertMetricDefinitionPayload,
  { rejectValue: string }
>(
  "dashboardSettings/upsertMetricDefinition",
  async (payload, thunkAPI) => {
    try {
      const res = await api.post("/policy/upsert-metric-definition", payload);
      return res.data.data;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message ||
          err.message ||
          "Failed to upsert metric definition",
      );
    }
  },
);

export const fetchHabitationalMetricDefinitions = createAsyncThunk<
  { data: IHabitationalMetricData[]; totalRecords: number },
  IFetchMetricDefinitionsParams,
  { rejectValue: string }
>(
  "dashboardSettings/fetchHabitationalMetricDefinitions",
  async ({ pageNumber, rowsInPerPage, limit }, thunkAPI) => {
    try {
      const res = await api.get(
        `/policy/get-habitational-metric-definition?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&pageLimit=${limit}`,
      );
      const data: IHabitationalMetricData[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      return { data, totalRecords };
    } catch (err: any) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message ||
          err.message ||
          "Failed to fetch habitational metric definitions",
      );
    }
  },
);

export const upsertHabitationalMetricDefinition = createAsyncThunk<
  IHabitationalMetricData,
  IUpsertHabitationalMetricPayload,
  { rejectValue: string }
>(
  "dashboardSettings/upsertHabitationalMetricDefinition",
  async (payload, thunkAPI) => {
    try {
      const res = await api.post(
        "/policy/upsert-habitational-metric-definition",
        payload,
      );
      return res.data.data;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message ||
          err.message ||
          "Failed to upsert habitational metric definition",
      );
    }
  },
);
